import { Ref } from "@tblabs/truffle";
import { BasketItemType } from "./BasketItemType";
import { ProductOption } from "./ProductOption";
import { RawBasketItem } from "./RawBasketItem";
import { RawProductInfo } from "./Product";
import { v4 as uuidv4 } from "uuid";


export abstract class BasketItem
{
    public abstract Type: BasketItemType;
    public abstract get AsString(): string;

    public Id: string = "";
    public ProductSerialNumber = new Ref<string>("");
    public AccessData = new Ref<string>("");
    public ProductInfo: RawProductInfo;
    public Option: ProductOption;
    public Quantity = new Ref<number>(1);
    public TotalPrice = new Ref<number>(0);

    constructor(raw: Partial<RawBasketItem>)
    {
        this.Id = raw.Id || uuidv4();
        this.ProductSerialNumber.value = raw.ProductSerialNumber || "";
        this.AccessData.value = raw.AccessData || "";
        this.ProductInfo = raw.ProductInfo || {} as RawProductInfo;
        this.Option = raw.Option || {} as ProductOption;
        this.Quantity.value = raw.Quantity || 1;
        this.TotalPrice.value = raw.TotalPrice || 0;
    }

    public get AsRaw(): RawBasketItem
    {
        return ({
            Id: this.Id,
            Type: this.Type,
            ProductSerialNumber: this.ProductSerialNumber.value,
            AccessData: this.AccessData.value,
            ProductInfo: this.ProductInfo,
            Option: this.Option,
            Quantity: this.Quantity.value,
            TotalPrice: this.TotalPrice.value,
        } as RawBasketItem);
    }

    public Set(product: { ProductInfo: RawProductInfo; ProductOption: ProductOption; }): void
    {
        this.ProductInfo = product.ProductInfo;
        this.Option = product.ProductOption;
    }
}
